// extracted by mini-css-extract-plugin
export default {"about-title-container":"about-titles_about-title-container__bMZAZ"};